import { calculatedDateColumn } from "./columns/calculated-date-column";
import { clicksColumn } from "./columns/clicks-column";
import { costTypeColumn } from "./columns/cost-type-column";
import { countryColumn } from "./columns/country-column";
import { createdByColumn } from "./columns/created-by-column";
import { createdDateColumn } from "./columns/created-date-column";
import { creativeColumn } from "./columns/creative-column";
import { downloadClientColumn } from "./columns/download-client-column";
import { downloadRateColumn } from "./columns/download-rate-column";
import { downloadedEpisodeColumn } from "./columns/downloaded-episode-column";
import { downloadsColumn } from "./columns/downloads-column";
import { downloadsPercentOfTotalColumn } from "./columns/downloads-percent-total";
import { firstMeasuredDateColumn } from "./columns/first-measured-date-column";
import { landingPageUrlColumn } from "./columns/landing-page-url-column";
import { lastMeasuredDateColumn } from "./columns/last-measured-date-column";
import { locationColumn } from "./columns/location-column";
import { newDownloadRateColumn } from "./columns/new-download-rate-column";
import { newDownloadsColumn } from "./columns/new-downloads-column";
import { newDownloadsPercentOfTotalColumn } from "./columns/new-downloads-percent-total";
import { placementColumn } from "./columns/placement-column";
import { placementCountColumn } from "./columns/placement-count-column";
import { promotedEpisodeColumn } from "./columns/promoted-episode";
import { promotedShowColumn } from "./columns/promoted-show-column";
import { promotionColumn } from "./columns/promotion-column";
import { publishedDateColumn } from "./columns/published-date-column";
import { showCategoryColumn } from "./columns/show-category-column";
import { typeColumn } from "./columns/type-column";

export const full = {
    promotions: {
        title: "Promotions",
        columns: [
            promotionColumn(true, true),
            typeColumn(),
            promotedShowColumn(),
            showCategoryColumn(),
            promotedEpisodeColumn(),
            landingPageUrlColumn(),
            placementCountColumn(),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
            createdDateColumn(),
            createdByColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    placements: {
        title: "Placements",
        columns: [
            placementColumn(true, true),
            locationColumn(false),
            costTypeColumn(),
            creativeColumn(),
            promotionColumn(false, true),
            typeColumn(),
            promotedShowColumn(),
            showCategoryColumn(),
            promotedEpisodeColumn(),
            landingPageUrlColumn(),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
            createdDateColumn(),
            createdByColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    locations: {
        title: "Locations",
        columns: [
            locationColumn(true),
            placementCountColumn(),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    creative: {
        title: "Creative",
        columns: [
            creativeColumn(true),
            placementCountColumn(),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    shows: {
        title: "Shows",
        columns: [
            promotedShowColumn(true),
            placementCountColumn(),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    episodes: {
        title: "Episodes",
        columns: [
            promotedEpisodeColumn(true),
            promotedShowColumn(),
            publishedDateColumn(),
            placementCountColumn(),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    countries: {
        title: "Countries",
        columns: [
            countryColumn(true),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    "download-clients": {
        title: "Download Clients",
        columns: [
            downloadClientColumn(true),
            downloadsColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadsPercentOfTotalColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
    "downloaded-episodes": {
        title: "Downloaded Episodes",
        columns: [
            downloadedEpisodeColumn(true),
            promotedShowColumn(),
            downloadsColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadsPercentOfTotalColumn(),
            firstMeasuredDateColumn(),
            lastMeasuredDateColumn(),
            calculatedDateColumn(),
        ],
    },
};

export const reduced = {
    placements: {
        title: "Summary",
        columns: [
            placementColumn(false, true),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
        ],
    },
    countries: {
        title: "Countries",
        columns: [
            countryColumn(true),
            clicksColumn(),
            downloadsColumn(),
            downloadRateColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadRateColumn(),
            newDownloadsPercentOfTotalColumn(),
        ],
    },
    "download-clients": {
        title: "Download Clients",
        columns: [
            downloadClientColumn(true),
            downloadsColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadsPercentOfTotalColumn(),
        ],
    },
    "downloaded-episodes": {
        title: "Downloaded Episodes",
        columns: [
            downloadedEpisodeColumn(true),
            downloadsColumn(),
            downloadsPercentOfTotalColumn(),
            newDownloadsColumn(),
            newDownloadsPercentOfTotalColumn(),
        ],
    },
};
